export default class ProjectPage {
    constructor(elm) {

        this.elm = elm;
        const dropdowns = elm.querySelectorAll('.facts-drop-down__title');
        const themeColor = elm.getAttribute('data-theme-color');

        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', function (e) {
                e.preventDefault();
                if (!dropdown.classList.contains('facts-drop-down__title--display')) {
                    dropdown.classList.add('facts-drop-down__title--display');
                    dropdown.nextElementSibling.classList.add('facts-drop-down__facts--display');
                } else {
                    dropdown.classList.remove('facts-drop-down__title--display');
                    dropdown.nextElementSibling.classList.remove('facts-drop-down__facts--display');
                }
            });

            document.addEventListener('click', function (event) {
                if (event.target !== dropdown) {
                    dropdown.classList.remove('facts-drop-down__title--display');
                    dropdown.nextElementSibling.classList.remove('facts-drop-down__facts--display');
                }
            });
        });


        if (themeColor) {
            document.querySelector('body').classList.add(themeColor);
        }
    }
}
